import api from "../security/api";
import apiMultipart from "../security/apiMultipart";

const findSourceField = (table) => {
    return api
        .post("information/findSourceField", table);
};

const searchRecord = (table, data, tradeAccountId, managerId) => {
    return api
        .get(`information/searchRecord/${table}/${data}?tradeAccountId=${tradeAccountId}&managerId=${managerId}`);
};

const searchRecordGroup = (table, data, group, field) => {
    return api
        .get(`information/searchRecordGroup/${table}/${data}/${group}/${field}`);
};

const save = (doc, client, esquema, functionParameter, email, arrayRequest, view) => {
    return api
        .post(`information/save?doc=${doc}&client=${client}&esquema=${esquema}&function=${functionParameter}&emailUsuario=${email}&view=${view}`, arrayRequest);
};

const update = (doc, client, esquema, functionParameter, email, data, view) => {
    return api
        .post(`information/update?doc=${doc}&client=${client}&esquema=${esquema}&function=${functionParameter}&emailUsuario=${email}&view=${view}`, data);
};

const deleteRecord = (doc, client, esquema, functionParameter, email, data) => {
    return api
        .post(`information/delete?doc=${doc}&client=${client}&esquema=${esquema}&function=${functionParameter}&emailUsuario=${email}`, data);
};

const viewTables = (table, data) => {
    return api
        .get(`information/viewTables`);
};

const searchView = (view, doc) => {
    return api
        .get(`information/searchView?view=${view}&doc=${doc}`);
};

const searchFunction = (functionParam, where) => {
    return api
        .post(`information/searchFunction?function=${functionParam}`, where);
};

const searchViewList = (view, doc, fields, offset, limit, where) => {
    return api
        .post(`information/searchViewList?view=${view}&doc=${doc}&fields=${fields}&offset=${offset}&limit=${limit}`, where);
};

const searchViewListRecordCount = (view, where) => {
    return api
        .post(`information/searchViewListRecordCount?view=${view}`, where);
};

const searchViewListTotal = (view, fields, where) => {
    return api
        .post(`information/searchViewListTotal?view=${view}&fields=${fields}`, where);
};

const redirectRecord = (view, id, where) => {
    return api
        .post(`information/redirectRecord?view=${view}&id=${id}`, where);
};

const searchContability = (esquema, id) => {
    return api
        .get(`information/searchContability?esquema=${esquema}&id=${id}`);
};

const searchDocuments = (entityType, entityProp, schema) => {
    return api
        .get(`information/searchDocuments?schema=${schema}&entityProp=${entityProp}&entityType=${entityType}`);
};

const searchGlobal = (client, schema, value, tradeAccountId, managerId) => {
    return api
        .get(`information/searchGlobal?client=${client}&schema=${schema}&value=${value}&page=1&size=1&tradeAccountId=${tradeAccountId}&managerId=${managerId}`);
};

const searchSource = (table, schema, fieldsRequest) => {
    return api
        .post(`information/searchSource?table=${table}&schema=${schema}`, fieldsRequest);
};

const tariff = (esquema, fieldsRequest) => {
    return api
        .post(`information/tariff?esquema=${esquema}&currencyId=0`, fieldsRequest);
};

const searchForeignCurrency = (esquema, date, currencyId) => {
    return api
        .get(`information/searchForeignCurrency?esquema=${esquema}&date=${date}&currencyId=${currencyId}`);
};

const searchSecurityType = () => {
    return api
        .get(`information/searchSecurityType`);
};

const tribute = (esquema, fieldsRequest) => {
    return api
        .post(`information/tribute?esquema=${esquema}`, fieldsRequest);
};

const searchAccount = (esquema, fieldsRequest) => {
    return api
        .post(`information/searchAccount?esquema=${esquema}`, fieldsRequest);
};

const post = (doc, client, esquema, functionParameter, email, request) => {
    return api
        .post(`information/post?doc=${doc}&client=${client}&esquema=${esquema}&function=${functionParameter}&emailUsuario=${email}`, request);
};

const reconcile = (doc, client, esquema, functionParameter, email, request) => {
    return api
        .post(`information/reconcile?doc=${doc}&client=${client}&esquema=${esquema}&function=${functionParameter}&emailUsuario=${email}`, request);
};

const argCvTsaTransfer = (doc, client, esquema, functionParameter, email, request) => {
    return api
        .post(`information/argCvTsaTransfer?doc=${doc}&client=${client}&esquema=${esquema}&function=${functionParameter}&emailUsuario=${email}`, request);
};

const searchEntityBalanceView = (esquema, entityPropertyId) => {
    return api
        .get(`information/searchEntityBalanceView?esquema=${esquema}&entityPropertyId=${entityPropertyId}`);
};

const searchEntityHoldingView = (esquema, entityPropertyId) => {
    return api
        .get(`information/searchEntityHoldingView?esquema=${esquema}&entityPropertyId=${entityPropertyId}`);
};

const searchViewListOwnerLedgerHomeAdmin = (view, doc, fields, offset, limit, where) => {
    return api
        .post(`information/searchViewListOwnerLedgerHomeAdmin?view=${view}&doc=${doc}&fields=${fields}&offset=${offset}&limit=${limit}`, where);
};

const searchViewListTotalOwnerLedgerHomeAdmin = (view, fields, where) => {
    return api
        .post(`information/searchViewListTotalOwnerLedgerHomeAdmin?view=${view}&fields=${fields}`, where);
};

const storeProcedure = (storeProcedure, esquema, dueDate, where) => {
    return api
        .post(`information/storeProcedure?storeProcedure=${storeProcedure}&esquema=${esquema}&dueDate=${dueDate}`, where);
};

const storeProcedurePosition = (storeProcedure, esquema, dueDate, where) => {
    return api
        .post(`information/storeProcedurePosition?storeProcedure=${storeProcedure}&esquema=${esquema}&dueDate=${dueDate}`, where);
};

const storeProcedurePerformance = (storeProcedure, esquema, fechaDesde, fechaHasta, where) => {
    return api
        .post(`information/storeProcedurePerformance?storeProcedure=${storeProcedure}&esquema=${esquema}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`, where);
};

const storeProcedureEntityBalanceAvailableAsOf = (storeProcedure, esquema, date, entityPropertyId, paymentSystemId) => {
    return api
        .post(`information/entityBalanceAvailableAsOf?storeProcedure=${storeProcedure}&esquema=${esquema}&date=${date}&entityPropertyId=${entityPropertyId}&paymentSystemId=${paymentSystemId}`);
};

const storeProcedureEntityHoldingAvailableAsOf = (storeProcedure, esquema, date, entityPropertyId, itemPropertyId) => {
    return api
        .post(`information/entityHoldingAvailableAsOf?storeProcedure=${storeProcedure}&esquema=${esquema}&date=${date}&entityPropertyId=${entityPropertyId}&itemPropertyId=${itemPropertyId}`);
};


const addGuarantee = (storeProcedure, esquema, trxId) => {
    return api
        .post(`information/addGuarantee?storeProcedure=${storeProcedure}&esquema=${esquema}&trxId=${trxId}`);
};

const argCnvTicket = (formData) => {
    return apiMultipart.post("information/argCnvTicket", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const pdfprotect = (formData) => {
    return apiMultipart.post(
        `information/pdfprotect`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            responseType: "blob"
        }
    );
};


const SystemDB = {
    findSourceField,
    save,
    searchRecord,
    update,
    deleteRecord,
    viewTables,
    searchView,
    searchFunction,
    searchViewList,
    searchRecordGroup,
    searchDocuments,
    searchGlobal,
    searchSource,
    searchContability,
    tariff,
    searchForeignCurrency,
    tribute,
    searchAccount,
    post,
    reconcile,
    argCvTsaTransfer,
    searchSecurityType,
    searchViewListRecordCount,
    searchViewListTotal,
    redirectRecord,
    searchEntityBalanceView,
    searchEntityHoldingView,
    searchViewListOwnerLedgerHomeAdmin,
    searchViewListTotalOwnerLedgerHomeAdmin,
    storeProcedure,
    storeProcedurePosition,
    storeProcedurePerformance,
    argCnvTicket,
    pdfprotect,
    storeProcedureEntityBalanceAvailableAsOf,
    storeProcedureEntityHoldingAvailableAsOf,
    addGuarantee
}

export default SystemDB;
